import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
const StateCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [region, setRegionRaw] = useState(localStorage.getItem("isoldit_state") || "QLD");

  useEffect(() => {
    if (!localStorage.getItem("isoldit_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const setRegion = (s) => { localStorage.setItem("isoldit_state", s); setRegionRaw(s); };
  const onAuth = ({ user, token }) => { localStorage.setItem("isoldit_token", token); setUser(user); };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("isoldit_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, onAuth, logout }}>
      <StateCtx.Provider value={{ region, setRegion }}>{children}</StateCtx.Provider>
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export const useRegion = () => useContext(StateCtx);
